<template>
  <v-layout>
    <!-- OFFICIAL FENCES -->
    <v-card max-width="1024" class="px-3 ml-2" :class="{'zones-card--compact': !showMedellinZones}" color="grey darken-4">
      <transition name="slide-fade">
        <v-flex v-if="showClearPolygons" class="clear-poly-style">
          Limpiar Zonas
        </v-flex>
      </transition>
      <v-fab-transition>
        <v-btn
          v-if="showClearPolygons"
          class="caption"
          color="primary"
          dark
          absolute
          top
          right
          fab
          small
          @click="clearAllOfficialPolygons"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-flex d-inline-flex align-center>
        <v-flex class="title-1 text-xs-right" pl-1 pt-1>
          <h2>Zonas Oficiales</h2>
        </v-flex>
        <v-flex d-inline-flex pl-3>
          <!-- NEIGHBORHOODS -->
          <template v-if="showMedellinZones">
          <v-icon class="pl-1" small color="purple">lens</v-icon>
          <v-autocomplete
            v-model="neighborhoodsSelectedIn"
            label="Barrio"
            :items="neighborhoods"
            class="mx-1"
            item-text="name"
            autocomplete
            clearable
            multiple
            @change="displayOfficialZones('neighborhoods')"
            @click:clear="clearOfficialZones('neighborhoods')"
            color="purple"
          >
            <template v-slot:selection="{ item, index }">
              <!-- <span v-if="index === 0 && index !== 1">{{ item.name }}</span> -->
                <v-chip v-if="index === 0" small style="maxWidth:60px;">

                <span
                  class="white--text caption text-truncate"
                  style="maxWidth:50px;"
                >
                  <!-- {{ neighborhoodsSelected.length === 1 ? item.name : `${neighborhoodsSelected.length} BAR` }} -->
                  {{ `${neighborhoodsSelected.length} BAR` }}
                </span>
                </v-chip>
            </template>
          </v-autocomplete>
          </template>
          <!-- COMMUNES -->
          <template v-if="showMedellinZones">
          <v-icon class="pl-1" small color="amber">lens</v-icon>
          <v-autocomplete
            v-model="communesSelectedIn"
            label="Comuna"
            :items="communesAlt"
            class="mx-1"
            item-text="name"
            autocomplete
            clearable
            multiple
            @input="displayOfficialZones('communes')"
            @click:clear="clearOfficialZones('communes')"
            color="amber"
          >
            <template v-slot:selection="{ item, index }">
              <!-- <span v-if="index === 0 && index !== 1">{{ item.name }}</span> -->
              <v-chip v-if="index === 0" small style="maxWidth:60px;">

                <span
                  class="white--text caption text-truncate"
                  style="maxWidth:50px;"
                >
                  <!-- {{ communesSelected.length === 1 ? item.name : `${communesSelected.length} COM` }} -->
                  {{ `${communesSelected.length} COM` }}
                </span>
              </v-chip>
            </template>
          </v-autocomplete>
          </template>
          <!-- QUADRANTS -->
          <v-icon class="pl-1" small color="light-green">lens</v-icon>
          <v-autocomplete
            v-model="quadrantsSelectedIn"
            label="Cuadrante"
            :items="quadrants"
            class="mx-1"
            item-text="name"
            autocomplete
            clearable
            multiple
            @input="displayOfficialZones('quadrants')"
            @click:clear="clearOfficialZones('quadrants')"
            color="light-green"
          >
            <template v-slot:selection="{ item, index }">
              <!-- <span v-if="index === 0 && index !== 1">{{ item.name }}</span> -->
                <v-chip v-if="index === 0" small style="maxWidth:60px;">

                <span
                  class="white--text caption text-truncate"
                  style="maxWidth:50px;"
                >
                  <!-- {{ quadrantsSelected.length === 1 ? item.name : `${quadrantsSelected.length} CUA` }} -->
                  {{ `${quadrantsSelected.length} CUA` }}
                </span>
                </v-chip>
            </template>
          </v-autocomplete>
          <!-- STATIONS -->
          <v-icon class="pl-1" small color="cyan">lens</v-icon>
          <v-autocomplete
            v-model="stationsSelectedIn"
            label="Estación"
            :items="stationsAlt"
            class="mx-1"
            item-text="name"
            autocomplete
            clearable
            multiple
            @input="displayOfficialZones('stations')"
            @click:clear="clearOfficialZones('stations')"
            color="cyan"
          >
            <template v-slot:selection="{ item, index }">
              <!-- <span v-if="index === 0 && index !== 1">{{ item.name }}</span> -->
                <v-chip v-if="index === 0" small style="maxWidth:60px;">

                <span
                  class="white--text caption text-truncate"
                  style="maxWidth:50px;"
                >
                  <!-- {{ stationsSelected.length === 1 ? item.name : `${stationsSelected.length} EST` }} -->
                  {{ `${stationsSelected.length} EST` }}
                </span>
                </v-chip>
            </template>
          </v-autocomplete>
          <template v-if="showEmpasZones">
          <v-icon class="pl-1" small color="orange darken-2">lens</v-icon>
          <v-autocomplete
            v-model="empasSelectedIn"
            label="EMPAS"
            :items="empas"
            class="mx-1"
            item-text="name"
            autocomplete
            clearable
            multiple
            @input="displayOfficialZones('empas')"
            @click:clear="clearOfficialZones('empas')"
            color="orange darken-2"
          >
            <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0" small style="maxWidth:60px;">

                <span
                  class="white--text caption text-truncate"
                  style="maxWidth:50px;"
                >
                  {{ `${empasSelected.length} EMP` }}
                </span>
                </v-chip>
            </template>
          </v-autocomplete>
          </template>
          <!-- DISTRICTS -->
          <template v-if="showMedellinZones">
          <v-icon class="pl-1" small color="deep-purple">lens</v-icon>
          <v-autocomplete
            v-model="districtsSelectedIn"
            label="Distrito"
            :items="districts"
            class="mx-1"
            item-text="name"
            autocomplete
            clearable
            multiple
            @input="displayOfficialZones('districts')"
            @click:clear="clearOfficialZones('districts')"
            color="deep-purple"
          >
            <template v-slot:selection="{ item, index }">
              <!-- <span v-if="index === 0 && index !== 1">{{ item.name }}</span> -->
                <v-chip v-if="index === 0" small style="maxWidth:60px;">

                <span
                  class="white--text caption text-truncate"
                  style="maxWidth:50px;"
                >
                  <!-- {{ districtsSelected.length === 1 ? item.name : `${districtsSelected.length} DIS` }} -->
                  {{ `${districtsSelected.length} DIS` }}
                </span>
                </v-chip>
            </template>
          </v-autocomplete>
          </template>
          <!-- FIREFIGHTERS -->
          <template v-if="showMedellinZones">
          <v-icon class="pl-1" small color="red darken-1">lens</v-icon>
          <v-autocomplete
            v-model="firefightersSelectedIn"
            label="Bomberos"
            :items="firefighters"
            class="mx-1"
            item-text="name"
            autocomplete
            clearable
            multiple
            @input="displayOfficialZones('firefighters')"
            @click:clear="clearOfficialZones('firefighters')"
            color="red lighten-2"
          >
            <template v-slot:selection="{ item, index }">
              <!-- <span v-if="index === 0 && index !== 1">{{ item.name }}</span> -->
                <v-chip v-if="index === 0" small style="maxWidth:60px;">

                <span
                  class="white--text caption text-truncate"
                  style="maxWidth:50px;"
                >
                  <!-- {{ firefightersSelected.length === 1 ? item.name : `${firefightersSelected.length} CB` }} -->
                  {{ `${firefightersSelected.length} CB` }}
                </span>
                </v-chip>
            </template>
          </v-autocomplete>
          </template>
        </v-flex>
      </v-flex>
    </v-card>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import { officialZonesMixin } from '../mixins/officialZonesMixin'

export default {
  name: 'official-zones',
  mixins: [officialZonesMixin],
  computed: {
    // ...mapGetters(['officialZonesHome']),
    ...mapGetters({
      firefighters: 'filters/getFirefighters',
      neighborhoods: 'filters/getNeighborhoods',
      communes: 'filters/getComunes',
      quadrants: 'filters/getQuadrants',
      stations: 'filters/getStations',
      districts: 'filters/getDistricts',
      empas: 'filters/getEmpas',
      clientId: 'auth/clientId',
      mapZoneMode: 'auth/mapZoneMode'
    }),
    showMedellinZones() {
      return this.mapZoneMode !== 'gobernacion'
    },
    showEmpasZones() {
      return this.mapZoneMode === 'gobernacion'
    },
    firefightersSelectedIn: {
      get() {
        return this.firefightersSelected
      },
      set(value) {
        const payload = {
          from: 'firefighters',
          value
        }
        this.setSelectedOfficialZone(payload)
      }
    },
    neighborhoodsSelectedIn: {
      get() {
        return this.neighborhoodsSelected
      },
      set(value) {
        const payload = {
          from: 'neighborhoods',
          value
        }
        this.setSelectedOfficialZone(payload)
      }
    },
    communesSelectedIn: {
      get() {
        return this.communesSelected
      },
      set(value) {
        const payload = {
          from: 'communes',
          value
        }
        this.setSelectedOfficialZone(payload)
      }
    },
    quadrantsSelectedIn: {
      get() {
        return this.quadrantsSelected
      },
      set(value) {
        const payload = {
          from: 'quadrants',
          value
        }
        this.setSelectedOfficialZone(payload)
      }
    },
    stationsSelectedIn: {
      get() {
        return this.stationsSelected
      },
      set(value) {
        const payload = {
          from: 'stations',
          value
        }
        this.setSelectedOfficialZone(payload)
      }
    },
    empasSelectedIn: {
      get() {
        return this.empasSelected
      },
      set(value) {
        const payload = {
          from: 'empas',
          value
        }
        this.setSelectedOfficialZone(payload)
      }
    },
    districtsSelectedIn: {
      get() {
        return this.districtsSelected
      },
      set(value) {
        const payload = {
          from: 'districts',
          value
        }
        this.setSelectedOfficialZone(payload)
      }
    }
  },
  methods: {
    ...mapActions([
      // 'fetchOfficialZonesHome',
      // 'saveOfficialZonesHome',
      'setSelectedOfficialZone',
      'clearAllOfficialPolygons',
      'clearOfficialZones',
      'displayOfficialZones'
    ])
  },
  async mounted() {
    // console.log('MOUNTED: route name', this.$route.name)
    // console.log('MOUNTED: route from', this.$route)
    // if (this.$route.name === 'AppVehicleViwer') {
    //   await this.saveOfficialZonesHome()
    //   this.clearAllOfficialPolygons()
    // }
    // else if (this.$route.name === 'BaseVehicles' && this.fromRoute.name === 'AppVehicleViwer') {
    //   await this.clearAllOfficialPolygons()
    //   if (this.officialZonesHome) this.fetchOfficialZonesHome()
    // }
  }
}
</script>

<style lang="stylus" scoped>
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .25s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.clear-poly-style {
  position: relative;
  top: 0px;
  left: 865px;
  font-size: 12px;
  font-weight: 600;
  width: 200px;
}

.zones-card--compact {
  position: relative;
}

.zones-card--compact .clear-poly-style {
  position: absolute;
  left: auto;
  right: 52px;
  top: 4px;
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/OfficialZones.vue